import { Component, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserProfileService } from '../../services/profile/user-profile.service';
import { UserProfileModel } from '../../models/profile/user-profile-model';
import { Notify } from 'notiflix/build/notiflix-notify-aio';
import { AuthService } from '../../services/auth/auth.service';
import { JwtTokenService } from '../../services/auth/jwt-token.service';

@Component({
    selector: 'app-profile',
    templateUrl: './profile.component.html',
    styleUrls: ['./profile.component.scss']
})
export class ProfileComponent {
    menuItems: any[] = [];
    selectedMenu: number = 6;
    userProfile: UserProfileModel = new UserProfileModel();

    constructor(
        private userProfileService: UserProfileService, 
        private authService: AuthService, 
        private router: Router, 
        private route: ActivatedRoute,
        private jwtTokenService: JwtTokenService) {

        this.menuItems = [
            {
                id: 6,
                text: 'My Profile',
                img: 'assets/images/user-profile.png'
            },
            {
                id: 2,
                text: 'My Orders',
                img: 'assets/images/shopping-cart-02.png'
            }
        ];
        
    }

    ngOnInit() {
        if (localStorage.getItem('cookie')) {
            this.cookiePopupVisibility = false;
        } else this.cookiePopupVisibility = true;

        this.jwtTokenService.getIsLogin().subscribe((data: any) => {
            if (data){
                this.menuItems.push({
                    id: 7,
                    text: 'Logout',
                    img: 'assets/images/exit-icon.png'
                });

                this.route.queryParams.subscribe(params => {
                    let id = params['id'];
                    if (id) {
                        this.openMenu(parseInt(id));
                    } else {
                        this.openMenu(this.selectedMenu);
                    }
                });

                this.loadUserProfile();

            } else this.router.navigate(['/home']);
        });
    }


    loadUserProfile() {
        this.userProfileService.getUserProfile().subscribe({
            next: (userProfile) => {
                this.userProfile = userProfile;   
                
            },
            error: (error) => {
                console.error(error);
                this.handleError.bind(this);
                localStorage.clear();
                this.router.navigate(['/home']);
            }
        });
    }


    openMenu(id: number) {
        this.selectedMenu = id;
        if (id == 7) {
            this.authService.logout().subscribe((res:any) => {
                console.log(res);
                /*
                
                localStorage.removeItem('id');
                localStorage.removeItem('expert');
                localStorage.removeItem('profile');
                localStorage.removeItem('token');
                localStorage.removeItem('userName');
                localStorage.removeItem('customer_id');
                localStorage.removeItem('email');
                this.router.navigate(["home"]);
                */
            });

            
            localStorage.removeItem('id');
            localStorage.removeItem('expert');
            localStorage.removeItem('profile');
            localStorage.removeItem('token');
            localStorage.removeItem('userName');
            localStorage.removeItem('customer_id');
            localStorage.removeItem('email');
            this.router.navigate(["home"]);
        }
    }

    handleError(error: any): void {
        Notify.failure(error.message + '- Operation unsuccessful', {
            position: 'right-top',
            timeout: 3000
        });
    }
    
    cookiePopupVisibility: boolean = false;
    customCookiePopupVisibility: boolean = false;
    
    acceptCookie() {
        localStorage.setItem('cookie', "1");
        this.cookiePopupVisibility = false;
    }
    customizeCookie() {
        this.cookiePopupVisibility = false;
        this.customCookiePopupVisibility = true;
    }
    rejectCookie() {
        this.cookiePopupVisibility = false;
    }
    acceptCookieOpen() {
        localStorage.setItem('cookie', "1");
        this.customCookiePopupVisibility= false;
    }
    customizeCookieOpen() {
        localStorage.setItem('cookie', "1");
        this.customCookiePopupVisibility = false;
    }
    rejectCookieOpen() {
        this.customCookiePopupVisibility = false;
    }
}

